<template>
  <div class="wishlistPage">
    <!-- <header-logged-in v-show="isLoggedIn"></header-logged-in> -->
    <banner-search></banner-search>
    <div class="bg-gradient-gray">
      <courseWishlist></courseWishlist>
      <trendingCourses  v-if="showTrendingCard && $store.getters.getWishListStoreData !== undefined && $store.getters.getWishListStoreData !== null && $store.getters.getWishListStoreData.length==0"></trendingCourses>
      <libraryCards  v-if="showTrendingCard && showLibraryCard && $store.getters.getWishListStoreData !== undefined && $store.getters.getWishListStoreData !== null && $store.getters.getWishListStoreData.length==0"></libraryCards>
      <newVideoCards  v-if="showTrendingCard && showLibraryCard && showTrendingCard && $store.getters.getWishListStoreData !== undefined && $store.getters.getWishListStoreData !== null && $store.getters.getWishListStoreData.length==0"></newVideoCards>
      <infinite-loading v-if="$store.getters.getWishListStoreData !== undefined && $store.getters.getWishListStoreData !== null && $store.getters.getWishListStoreData.length==0" @infinite="infiniteHandler" spinner="waveDots" ref="infiniteLoader">
        <span slot ='no-results'></span>
        <span slot ='no-more'></span>
    </infinite-loading>
    </div>
 </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import { EventBus } from '@/main.js'
import bannerSearch from '@/components/home/bannerSearch'
import courseWishlist from './courseWishList'
import courseCards from '@/components/home/courseCards'
import libraryCards from '@/components/home/libraryCards'
import newVideoCards from '@/components/home/newVideoCards'
import trendingCourses from '@/components/home/trendingCourses'
export default {
  name: 'wishlist',
  components: {
    bannerSearch,
    courseCards,
    InfiniteLoading,
    courseWishlist,
    libraryCards,
    newVideoCards,
    trendingCourses
  },
  data () {
    return {
      showTrendingCard: false,
      showLibraryCard: false,
      showNewVideoCard: false,
      globalState: ''
    }
  },
  computed: {
    isLoggedIn () {
      return this.$store.getters.getIsLoggedIn
    }
  },
  created () {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed () {
    window.removeEventListener('scroll', this.handleScroll)
  },
  mounted () {
    EventBus.$emit('showNav', true)
  },
  methods: {
    // infiniteHandler - starts lazy loading
    infiniteHandler ($state) {
      this.globalState = $state
      setTimeout(() => {
        this.showTrendingCard = true
        // this.showLibraryCard = true
        $state.loaded()
      }, 2000)
    },
    // handleScroll - handles scrolling
    handleScroll () {
      if (this.showTrendingCard && !this.showLibraryCard) {
        setTimeout(() => {
          this.showLibraryCard = true
          if (this.$refs.infiniteLoader !== undefined) {
            // this.$refs.infiniteLoader.$emit('$InfiniteLoading:complete')
            this.globalState.complete()
          }
        }, 2000)
      } else if (this.showTrendingCard && this.showLibraryCard) {
        setTimeout(() => {
          this.showNewVideoCard = true
          if (this.$refs.infiniteLoader !== undefined) {
            // this.$refs.infiniteLoader.$emit('$InfiniteLoading:complete')
            this.globalState.complete()
          }
        }, 2000)
      }
    }
  }
}
</script>
<style lang="scss">
.wishlistPage{
  .bg-gradient-gray{
          background: linear-gradient(to bottom, #fafafa 0%,#ffffff 100%); 
  }
}
</style>




// WEBPACK FOOTER //
// src/components/wishList/wishList.vue?34923c91